import styled, {
  css,
  FlattenSimpleInterpolation,
} from 'styled-components/macro';
import { IInputSize } from '../types';

export const Height: { [key in IInputSize]: FlattenSimpleInterpolation } = {
  l: css`
    height: 276px;
  `,
  m: css`
    height: 184px;
  `,
  s: css`
    height: 92px;
  `,
  inherit: css`
    height: inherit;
  `,
};

export const Textarea = styled.textarea<{ height: IInputSize }>`
  ${(props) => Height[props.height]};
  max-height: 500px;
  width: 100%;
  max-width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  outline: none;
  background-color: transparent;
  border: 1px solid;
  transition: all 150ms;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  resize: vertical;
`;
